module.exports = __webpack_public_path__ + "img/btn_Google.848e7bd0.png";